(function ($) {
    $(document).ready(function () {
        const myajax = `${window.location.protocol}//${window.location.host}/wp-admin/admin-ajax.php`;

        let paramObj = {
            url: myajax,
            action: 'works_ajax',
            category: '',
            paged: 1,
            callType: 'default',
        };

        let isLoaded = true;

        function updateGlass() {
            const worksGlass =
                parseInt($('.js-works-list').css('width'), 10) +
                parseInt($('.js-works-container').css('padding-right'), 10) +
                parseInt($('.js-works-container').css('margin-right'), 10);

            $('.page-works .work-content-glass').css('width', worksGlass);
        }

        function filters(paramObj) {
            $.ajax({
                url: paramObj.url,
                data: paramObj,
                type: 'post',

                beforeSend() {
                    isLoaded = false;

                    if (paramObj.callType === 'default') {
                        $('.js-works-list').css('opacity', '0.4');
                        $('body').addClass('works-loading');
                    }

                    if (paramObj.callType === 'loadmore') {
                        $('body').addClass('works-loading-more');
                    }
                },
                success(result) {
                    if (paramObj.callType === 'default') {
                        $('html, body').animate(
                            {
                                scrollTop:
                                    $('.js-works-list').offset().top - 120,
                            },
                            300
                        );

                        $('.js-works-list').html(result);

                        paramObj.paged = 1;
                    } else if (paramObj.callType === 'loadmore') {
                        $('.js-append-projects').append(result);
                    }
                },

                complete() {
                    $('.js-works-list').css('opacity', '1');

                    $('body').removeClass('works-loading works-loading-more');

                    isLoaded = true;

                    updateGlass();
                },

                error(error) {
                    console.error(error);
                    isLoaded = true;
                },
            });
        }

        $(document).on('click', '.js-works-category', function (e) {
            e.preventDefault();

            if (!isLoaded) {
                return;
            }

            isLoaded = false;

            paramObj.paged = 1;
            paramObj.category = $(this).data('value');
            paramObj.callType = 'default';

            filters(paramObj);

            $('.js-works-category').removeClass('active');
            $(this).addClass('active');
        });

        const observerTarget = document.querySelector('.js-load-works');

        if (observerTarget) {
            const observer = new IntersectionObserver(
                (entries) => {
                    const entry = entries[0];

                    if (!entry.isIntersecting) {
                        return;
                    }

                    if (!isLoaded) {
                        return;
                    }

                    const projectsContainer =
                        document.querySelector('.js-append-projects');

                    if (!projectsContainer) {
                        return;
                    }

                    const maxPages = parseInt(
                        projectsContainer.dataset.pages || 1,
                        10
                    );

                    if (paramObj.paged >= maxPages) {
                        return;
                    }

                    isLoaded = false;

                    paramObj.paged += 1;
                    paramObj.callType = 'loadmore';

                    filters(paramObj);
                },
                {
                    rootMargin: '300px',
                }
            );

            observer.observe(observerTarget);
        }
    });
})(jQuery);

$(window).on('load resize', function () {
    if ($('.js-works-list').length) {
        const worksGlass =
            parseInt($('.js-works-list').css('width'), 10) +
            parseInt($('.js-works-container').css('padding-right'), 10) +
            parseInt($('.js-works-container').css('margin-right'), 10);

        $('.page-works .work-content-glass').css('width', worksGlass);
        $('.works').css('overflow', 'visible');
    }
});